window.mcb.forms.helpers = (function () {
  const _logger = window.mcb.utilities.createLogger('forms.helpers');
  let renderedFileSizes = {
    150000000: '150mb',
    25000000: '25mb',
    20000000: '20mb',
    6000000: '6mb',
    2000000: '2mb'
  };

  const _classOfConditionActive = window.mcb.forms.constants.classRoot + 'conditional--active';

  return _ = {
    htmlEncode: function (value) {
      return jQuery("<div/>")
        .text(value)
        .html();
    },
    htmlDecode: function (value) {
      return jQuery("<div/>")
        .html(value)
        .text();
    },
    getDateFormat: function (targetId, dateonly = true) {
      let includeTime = dateonly === false;
      let key = includeTime ? 'DateTimeFormat' : 'DateFormat';
      let res = window.mcb.forms.data.getMessageFromToken(
        targetId,
        key
      );
      if (res === key) {
        return includeTime ? "dd-mm-yyyy hh:MM" : "dd-mm-yyyy";
      }

      return res;
    },
    getSageDateFormat: function (format) {
      return format
        .replace("MM", "%m")
        .replace("dd", "%d")
        .replace("yyyy", "%Y")
        .replace("mm", "%M")
        .replace("HH", "%H")
        .replace("hh", "%H");
    },
    generateUUID: function () {
      let d = new Date().getTime();
      let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16;
        if (d > 0) {
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        }
        else {
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }

        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },
    generateModulusValue: function (startsWith, modulus, weights) {
      let requiredLength = weights.length;
      let result = startsWith;
      let sum = 0;
      for (let i = 0; i < requiredLength - 1; i++) {
        if (result.length < i + 1) {
          result += '0';
        }
        else {
          sum += parseInt(result[i]) * weights[i];
        }
      }

      result += (modulus - (weights[requiredLength - 1] * (sum % modulus))).toString();

      return result;
    },
    getFormIsBlockedMessage: function (originalFormSettings) {
      try {
        let formSettings = jQuery.extend(
          true,
          {
            /* Sample input (Note datetimes are UTC Zulu time!):
            endpointmaintenancemessage: 'message',
            endpointMaintenanceEnd: new Date('2021-04-24T16:00:00Z'),
            endpointMaintenanceStart: new Date('2021-04-23T16:00:00Z')*/
          },
          originalFormSettings
        );

        if (typeof formSettings.endpointmaintenancemessage === 'undefined' || typeof formSettings.endpointMaintenanceStart === 'undefined' || formSettings.endpointMaintenanceStart === null) {
          return null;
        }

        if (typeof formSettings.endpointMaintenanceEnd === "string") {
          formSettings.endpointMaintenanceEnd = new Date(formSettings.endpointMaintenanceEnd);
        }

        if (typeof formSettings.endpointMaintenanceStart === "string") {
          formSettings.endpointMaintenanceStart = new Date(formSettings.endpointMaintenanceStart);
        }

        let displayState = "";
        let fallbackEndText = 'later';
        if (typeof formSettings.endpointMaintenanceEnd !== 'undefined') {
          displayState += " until " + formSettings.endpointMaintenanceEnd;
          fallbackEndText += " after " + formSettings.endpointMaintenanceEnd;
        }

        _logger.trace("Form blocking is active: from " + formSettings.endpointMaintenanceStart + displayState);

        let now = new Date().getTime();
        let overrideNow = window.mcb.utilities.browser.getUrlParameter('now');
        if (overrideNow !== "") {
          let ts = parseInt(overrideNow);
          if (!isNaN(ts)) {
            overrideNow = ts;
          }

          now = new Date(overrideNow);
          _logger.trace('Override "now" time: ' + now);
          if (!(now instanceof Date && !isNaN(now))) {
            _logger.warn('Override "now" is invalid!');
            now = new Date().getTime();
          }
        }

        if (now > formSettings.endpointMaintenanceStart.getTime()) {                                                                                                               // 'now' is AFTER the locking begin stamp
          if (typeof formSettings.endpointMaintenanceEnd === 'undefined' || formSettings.endpointMaintenanceEnd === null || now < formSettings.endpointMaintenanceEnd.getTime()) { // There are NO endpoint, or the enpoint is in the future
            _logger.warn("Form was blocked");

            if (window.mcb.utilities.browser.getUrlBooleanParameter('test')) {
              _logger.warn("Form was blocked, but testing is active");
              return null;
            }

            if (typeof formSettings.endpointmaintenancemessage === 'undefined' || formSettings.endpointmaintenancemessage === null || formSettings.endpointmaintenancemessage.trim() === "") {
              _logger.error("Form was blocked, but no message found");
              return 'Please try again ' + fallbackEndText;
            }

            if (typeof originalFormSettings.messages.endpointmaintenancemessage !== 'undefined' && originalFormSettings.messages.endpointmaintenancemessage !== null && originalFormSettings.messages.endpointmaintenancemessage.trim() !== "") {
              return originalFormSettings.messages.endpointmaintenancemessage;
            }

            return formSettings.endpointmaintenancemessage;
          }
        }
      }
      catch (err) {
        _logger.error(err);
      }

      return null;
    },
    renderFileSize: function (sizeInBytes) {
      let result = renderedFileSizes[sizeInBytes] ?? null;
      if (result === null) {
        if (sizeInBytes >= 1000000 && sizeInBytes % 1000000 < 10000) {
          result = Math.floor(sizeInBytes / 1000000) + 'mb';
        }
        else {
          result = Math.floor(sizeInBytes / 1000) + 'kb';
        }

        renderedFileSizes[sizeInBytes] = result;
      }

      return result;
    },
    evaluateCondition: function (conditianalObject, conditianalElement, condition, origin, currentOriginValue) {
      if (
        condition != null &&
        condition.rules.length > 0 &&
        origin.alias !== conditianalObject.alias &&
        !condition.rules.some(r => r.reference == origin.alias)) {
        _logger.warn('rules no matchy', condition.rules, origin.alias);
      }

      if (
        condition != null &&
        condition.rules.length > 0 &&
        origin.alias !== conditianalObject.alias &&
        condition.rules.some(r => r.reference == origin.alias)) {

        conditianalObject.conditionReferenceValues[origin.alias] = currentOriginValue;

        _logger.trace('evaluateCondition is running', conditianalObject, conditianalElement, condition, origin, currentOriginValue);

        const rules = condition.rules;
        const results = [];
        for (let i = 0; i < rules.length; i++) {
          const operator = rules[i].operator;
          const reference = rules[i].reference;
          const value = rules[i].value;
          const current = conditianalObject.conditionReferenceValues[reference] ?? null;
          if (current === null) {
            return;
          }

          if (operator === 'is') {
            results.push(current === value);
          }
          else if (operator === 'is-not') {
            results.push(current !== value);
          }
          else {
            _logger.error('NotImplementet Operator:', operator);
          }
        }

        if (results.length == rules.length) {
          conditianalElement.classList.remove(_classOfConditionActive);
          const logic = condition.logicType;
          if (logic === 'any') {
            if (results.indexOf(true) >= 0) {
              _logger.trace('evaluateCondition is activating target based on "Any" logic', conditianalObject, conditianalElement, condition, origin, currentOriginValue);
              conditianalElement.classList.add(_classOfConditionActive);
            }
          }
          else if (logic === 'all') {
            if (results.indexOf(false) < 0) {
              _logger.trace('evaluateCondition is activating target based on "All" logic', conditianalObject, conditianalElement, condition, origin, currentOriginValue);
              conditianalElement.classList.add(_classOfConditionActive);
            }
          }
          else {
            _logger.error('NotImplementet Logic:', logic);
          }
        }
      }
    }
  };
})();
